/* Blue Skin – scroll reveal + split titles */
(function () {
  if (window.bslAnim) return; window.bslAnim = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('bsl-js');

  function split(el, letters, step) {
    if (el.getAttribute('data-bsl-split')) return;
    el.setAttribute('data-bsl-split', '1');
    el.classList.add('bsl-split');
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(' ')); return; }
            var ws = document.createElement('span'); ws.className = 'bsl-w';
            if (letters) {
              Array.prototype.slice.call(w).forEach(function (ch) {
                var s = document.createElement('span'); s.className = 'bsl-l'; s.textContent = ch;
                s.style.transitionDelay = (i++ * step) + 'ms'; ws.appendChild(s);
              });
            } else {
              var s2 = document.createElement('span'); s2.className = 'bsl-wi'; s2.textContent = w;
              s2.style.transitionDelay = (i++ * step) + 'ms'; ws.appendChild(s2);
            }
            frag.appendChild(ws);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR' && n.tagName !== 'SVG') {
          walk(n);
        }
      });
    })(el);
  }

  var REVEAL = 'h2, h3, h4, p, li, img, a.bsl-btn, tbody tr, details, iframe, form, .bsl-gr__card, .bsl-cd__card, .bsl-py__card, .card-wrapper';
  var io;

  function hero() {
    document.querySelectorAll('.bsl-hero2__title, .bsl-ph__copy h1').forEach(function (h) {
      split(h, true, 26);
      setTimeout(function () { h.classList.add('bsl-in'); }, 120);
    });
    document.querySelectorAll('.bsl-hero2__script').forEach(function (h) {
      split(h, false, 110);
      setTimeout(function () { h.classList.add('bsl-in'); }, 60);
    });
    document.querySelectorAll('.bsl-hero2__text, .bsl-hero2 .bsl-btn, .bsl-ph__copy > p, .bsl-ph__copy > div, .bsl-ph__copy .bsl-btn').forEach(function (el, k) {
      el.classList.add('bsl-rv');
      el.style.transitionDelay = (550 + k * 140) + 'ms';
      setTimeout(function () { el.classList.add('bsl-in'); }, 60);
      setTimeout(function () { el.style.transitionDelay = ''; }, 2400);
    });
  }

  function setup() {
    if (document.documentElement.classList.contains('bsl-splashing') && !window.bslSplashDone) {
      document.querySelectorAll('.bsl-hero2__title, .bsl-ph__copy h1').forEach(function (h) { split(h, true, 26); });
      document.querySelectorAll('.bsl-hero2__script').forEach(function (h) { split(h, false, 110); });
      document.addEventListener('bsl:splashdone', hero, { once: true });
    } else {
      hero();
    }

    io = new IntersectionObserver(function (entries) {
      var shown = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
      shown.sort(function (a, b) { return a.compareDocumentPosition(b) & 2 ? 1 : -1; });
      shown.forEach(function (el, k) {
        if (!el.classList.contains('bsl-split')) el.style.transitionDelay = Math.min(k * 90, 630) + 'ms';
        el.classList.add('bsl-in');
        io.unobserve(el);
        setTimeout(function () { el.style.transitionDelay = ''; }, 1700);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    var scopes = document.querySelectorAll('main .shopify-section, .shopify-section-group-footer-group');
    scopes.forEach(function (sec) {
      if (sec.querySelector('.bsl-th')) return;
      sec.querySelectorAll('.bsl-d__title, .bsl-sy__title').forEach(function (t) {
        split(t, false, 75);
        io.observe(t);
      });
      sec.querySelectorAll(REVEAL).forEach(function (el) {
        if (el.closest('.bsl-split') || el.closest('.bsl-rv') || el.closest('header')) return;
        if (el.closest('.bsl-pr__table') && el.tagName !== 'TR') return;
        if (el.closest('.card-wrapper') && !el.classList.contains('card-wrapper')) return;
        el.classList.add('bsl-rv');
        io.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();

  /* Theme editor: re-run on section reload */
  document.addEventListener('shopify:section:load', function () { if (io) setup(); });
})();
